<template>
<div class="ti">
  <div style="margin-left: 20px; margin-top: 20px; margin-bottom: 20px">
    <el-row>
    </el-row>
    <el-row>
      <el-col :span="4">
        分类：
        <el-select v-model="search.type_id" filterable placeholder="选择分类" clearable size="mini">
          <el-option
            v-for="(item,index) in search.type_list"
            :key="index"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-col>
      <el-col :span="4">
        战区：
        <el-select v-model="search.region" placeholder="请选择战区" filterable clearable size="mini">
          <template v-for="item in search.region_list">
            <el-option :label="item.name" :value="item.id"/>
            <template v-for="sub in item.children">
              <el-option :label="'  - ' + sub.name" :value="sub.id" />
            </template>
          </template>
        </el-select>
      </el-col>
      <el-col :span="4">
        项目：
        <el-select v-model="search.project" placeholder="请选择项目"  filterable clearable size="mini">
          <template v-for="(item,index) in search.project_list">
            <el-option :label="item.house_name" :value="item.erp_pindex_id"></el-option>
          </template>
        </el-select>
      </el-col>
      <el-col :span="4">
        区域：
        <el-select v-model="search.area" placeholder="请选择区域" filterable clearable size="mini">
          <template v-for="(item,index) in search.area_list">
            <el-option :label="item.house_name" :value="item.house_id"></el-option>
          </template>
        </el-select>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="4">
        编号：
        <el-input size="mini" v-model="search.services_id" clearable placeholder="请输入编号" style="width: 80%" @input="searchData()"></el-input>
      </el-col>
      <el-col :span="4">
        类型：
        <el-select v-model="search.site" placeholder="请选择类型" clearable size="mini" clearable @change="searchData">
          <el-option label="-所有类型-" value=""></el-option>
          <el-option label="公区维修" value="1"></el-option>
          <el-option label="居家报修" value="2"></el-option>
          <el-option label="公区卫生" value="3"></el-option>
          <el-option label="公区安全" value="4"></el-option>
          <el-option label="公区绿化" value="5"></el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        预警级别：
        <el-select v-model="search.is_timeout" placeholder="请选择预警级别" clearable clearable size="mini" @change="searchData">
          <el-option label="-全部-" value=""></el-option>
          <el-option label="一级预警" value="1"></el-option>
          <el-option label="二级预警" value="2"></el-option>
          <el-option label="三级预警" value="3"></el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        工单来源：
        <el-select v-model="search.member_type" placeholder="请选择工单来源" clearable size="mini"
                   @change="searchData">
          <el-option label="-所有来源-" value=""></el-option>
          <el-option label="业主工单" value="1"></el-option>
          <el-option label="物业工单" value="2"></el-option>
          <el-option label="集团品控工单" value="6"></el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-button size="mini" style="color: #FFFFFF" type="primary" @click="searchData">搜索</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        选择日期：
        <el-date-picker
          v-model="search.dateArr[0]"
          type="date"
          @change="searchData"
          value-format="yyyy-MM-dd"
          placeholder="选择日期">
        </el-date-picker>
        至
        <el-date-picker
          v-model="search.dateArr[1]"
          type="date"
          @change="searchData"
          value-format="yyyy-MM-dd"
          placeholder="选择日期">
        </el-date-picker>
      </el-col>
    </el-row>

  </div>
  <v-divider></v-divider>
  <el-table :data="dataList" v-loading="loading" stripe style="width: 100%">
    <el-table-column prop="services_id" label="编号"></el-table-column>
    <el-table-column prop="name" label="姓名"></el-table-column>
    <el-table-column prop="tel" label="电话"></el-table-column>
    <el-table-column prop="house_name" label="项目"></el-table-column>
    <el-table-column prop="address" label="位置"></el-table-column>
    <el-table-column prop="content" label="报修内容" width="200" show-overflow-tooltip="true"></el-table-column>
    <el-table-column label="类型">
      <template slot-scope="scope">
        <template v-if="scope.row.site == 1">
          公区维修
        </template>
        <template v-if="scope.row.site == 2">
          居家报修
        </template>
        <template v-if="scope.row.site == 3">
          公区卫生
        </template>
        <template v-if="scope.row.site == 4">
          公区安全
        </template>
        <template v-if="scope.row.site == 5">
          公区绿化
        </template>
      </template>
    </el-table-column>
    <el-table-column prop="member_type_text" label="工单来源"></el-table-column>
    <el-table-column prop="is_timeout_text" label="预警"></el-table-column>
    <el-table-column prop="status_text" label="状态"></el-table-column>
    <el-table-column prop="hang_up_message" label="暂挂的原因"></el-table-column>
    <el-table-column prop="hang_up_user" label="同意暂挂的批准人"></el-table-column>
    <el-table-column prop="created_at_text" label="提交时间"></el-table-column>
    <el-table-column label="操作">
      <template slot-scope="scope">
        <el-button style="color: #FFFFFF" type="primary" size="mini" @click="getDetail(scope.row)">查看</el-button>
      </template>
    </el-table-column>
  </el-table>
  <v-divider></v-divider>
  <div class="pagination-wrap" >
    <el-pagination background layout="prev, pager, next" :total="search.total*1" :page-size="search.page_size*1" :current-page="search.page_num*1" @current-change="pageChange"></el-pagination>
  </div>
  <repairs-detail ref="RepairsDetail" />
</div>
</template>

<script>
import RepairsDetail from "./RepairsDetail";
import Http from "../../Oa/common/OaHttp";
import UserProjectInfo from "../../Butler/common/UserProjectInfo";

const statusArr = ['待受理', '待回访', '待评价', '已评价', '暂挂', '无效工单'];
export default {
  name: 'HangUpRepair',
  components: {RepairsDetail},
  data () {
    return {
      isIndeterminate: false,
      status_total: [],
      loading: false,
      search: {
        dateArr: [],
        statusList : statusArr,
        select_status: [],
        services_id: '',
        site: '',
        is_timeout: '',
        region:'',
        region_list: [],
        project:'',
        project_list:[],
        page_size: 20,
        page_num: 1,
        total: 0,
        start_date: '',
        end_date: '',
        member_type: '',
        report_type: 'hang_up',
        checkAll: false,
        area:'',
        area_list:'',
        project_ids:'',
        type_id : '',
        type_list : []
      },
      dataList : [],
      projectRegion:[],
      projectList:[],
      areaList:[],
      regionListKeyById: {},
    }
  },
  //界面没出来前加载
  created() {

  },

  mounted(){
    this.search.dateArr = this.getNowTime();

  },
  activated(){
    let region =  this.$route.query.region_name;
    let project =  this.$route.query.project_name;
    let member_type =  this.$route.query.member_type;
    let start_date =  this.$route.query.start_date;
    let end_date =  this.$route.query.end_date;

    // this.getRegionList()
    this.search.type_id = 1
    let that = this
    UserProjectInfo.ready(function(){
      that.search.type_list=UserProjectInfo.getTypeList();
      that.search.region_list = UserProjectInfo.getRegionList(that.search.type_id);
    },1)

  },
  computed:{

  },
  watch: {
    'search.type_id':function(newValue) {
      this.search.region = ''
      this.search.project = ''
      this.search.area = ''
      if (newValue === "") {
        this.search.region_list = []
        this.search.project_list = []
        this.search.area_list = []
      } else {
        this.search.region_list = UserProjectInfo.getRegionList(newValue);
      }

      this.search.project_ids = UserProjectInfo.getProjectIds(0,newValue)
      this.getRepairList()

    },
    'search.region':function(newValue) {
      this.search.project = ''
      this.search.area = ''
      if (newValue === "") {
        this.search.project_list = []
        this.search.area_list = []
      } else {
        this.search.project_list=UserProjectInfo.getProjectList(this.search.region,this.search.type_id);
      }

      this.search.project_ids = UserProjectInfo.getProjectIds(this.search.region,this.search.type_id)
      this.getRepairList()
    },
    'search.project':function(newValue) {
      this.search.area = ''
      if (newValue === "") {
        this.search.area_list = []
        this.search.project_ids = UserProjectInfo.getProjectIds(this.search.region,this.search.type_id)
      } else {
        this.search.project_ids = newValue
        this.search.area_list = UserProjectInfo.getAreaList(newValue);
      }
      this.getRepairList()
    },
    'search.area':function(newValue) {
      this.getRepairList()
    }
  },
  //事件
  methods: {
    handleCheckAllChange(val) {
      this.search.select_status = val ? statusArr : [];
      this.isIndeterminate = false;
      this.searchData()
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.search.checkAll = checkedCount === this.search.statusList.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.search.statusList.length;
    },
    searchData() {
      this.search.page_num = 1
      this.getRepairList()
    },
    pageChange(i) {
      this.search.page_num = i
      this.getRepairList()
    },
    getRepairList() {
      if (this.search.dateArr.length < 2) {
        this.$message.error("请选择日期");
        return false
      }
      if (this.search.project_ids == '') {
        let projectIds = [];
        for (const k in this.search.region_list) {
          let item = this.search.region_list[k]
          let list = this.getProjectListByRegion(item.id)
          projectIds.push(list.map(item => item.erp_pindex_id))
        }
        this.search.project_ids = projectIds.join(',');
      }
      this.search.start_date = this.search.dateArr[0];
      this.search.end_date = this.search.dateArr[1];
      this.loading = true
      this.$myhttp.post('admin/getReportForRepair',this.search,{
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{ // 异步执行成功后
        this.loading = false
        let resData = backdata['data'];

        if(resData.code == 200){
          this.search.total = resData.total
          this.dataList = resData.list
          // 统计各个状态数量
          this.status_total = resData.status_total[0]
        }
      });
    },
    getRegionList() {
      let that = this
      Http.get(Http.getFlowBaseURL() + "/hrm/User/getUserProjectInfo", {'status':0}, res => {
        if (res.code == 0) {
          that.projectRegion = this.getRegionTree(0, res.data.region_list)
          that.projectList = res.data.project_list
          that.areaList = res.data.area_list

          for (const k in res.data.region_list) {
            this.regionListKeyById[res.data.region_list[k]['id']] = res.data.region_list[k];
          }

          that.search.region_list = this.getRegionTree(0, res.data.region_list)
          this.getRepairList()
        }
      });
    },
    // 战区列表转为树结构
    getRegionTree(id, d) {
      let list = []
      for(const k in d) {
        if(d[k].pid == id) {
          let item = d[k]
          item.children = this.getRegionTree(item.id, d)
          list.push(item)
        }
      }
      return list
    },
    selectRegion() {
      this.search.project = '';
      this.search.area = '';
      this.search.project_list = this.getProjectListByRegion(this.search.region);
      this.search.project_ids = this.getProjectIds(this.search);
      this.searchData()
    },
    selectProject() {
      this.search.area = '';
      this.search.area_list = this.getAreaList(this.search.project);
      this.searchData()
    },
    getDetail(item){
      this.$refs.RepairsDetail.show(item.id)
    },
    getNowTime() {
      // let start = new Date(new Date().getTime() - 3600 * 1000 * 24 * 30)
      //     .toISOString()
      //     .replace('T', ' ')
      //     .split('.')[0] //默认开始时间7天前

      let year = new Date().getFullYear();
      let month = new Date().getMonth();
      month = month + 1;
      if (month < 10 ) {
        month = '0' + month;
      }
      let start = year + '-' + month + '-01';

      let end = new Date(new Date().getTime())
        .toISOString()
        .replace('T', ' ')
        .split('.')[0]//默认结束时间

      // start = start.substring(0,10)
      end = end.substring(0,10)
      return [start, end]
    },
    // 获取战区项目列表
    getProjectListByRegion(projectRegionId) {
      if (projectRegionId) {
        const regionItem = this.getRegion(projectRegionId)
        return this.projectList.filter(item => regionItem.pindex_id.includes(item.erp_pindex_id + ''))
      } else {
        return this.projectList
      }
    },

    // 获取项目的区域
    getAreaList(projectId) {
      if (projectId) {
        const projectItem = this.getProject(projectId)
        return this.areaList.filter(item => item.erp_pindex_id == projectItem.erp_pindex_id)
      } else {
        return []
      }
    },

    getRegion(id) {
      // let projectRegion = this.projectRegion
      // for (const k in projectRegion) {
      //   if (projectRegion[k].id == id) {
      //     return projectRegion[k]
      //   }
      // }
      return this.regionListKeyById[id];
    },

    getProject(id) {
      let projectList = this.projectList
      for (const k in projectList) {
        if (projectList[k].erp_pindex_id == id) {
          return projectList[k]
        }
      }
    },
    getProjectIds(data){
      let project_id = '';
      if(data.project) {
        project_id = data.project
      } else {
        if(data.region) {
          const list = this.getProjectListByRegion(data.region)
          project_id = list.map(item => item.erp_pindex_id).join(',')
        } else {
          project_id = this.projectList.map(item => item.erp_pindex_id).join(',')
        }
      }
      return project_id;
    }
  },

}
</script>
<style scoped>
.el-row {
  margin-bottom: 10px;
}
.ti{
  margin: 1%;
  width: 98%;
}
.pagination-wrap {
  display: flex;
  justify-content: center;
  margin-top: 15px;
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/App/Repair/HangUpRepair.vue